import {useCallback} from 'react'

import {DOM_ANIMATION_IDS} from './../ProductAnnouncementBanner.data'

import Styles from './ProductAnnouncementBannerAnimation.module.css'

export interface ProductAnnouncementBannerAnimationProps {
  sceneId: (typeof DOM_ANIMATION_IDS)[number]
}

const defaultProps: Partial<ProductAnnouncementBannerAnimationProps> = {}

const ProductAnnouncementBannerAnimation = (props: ProductAnnouncementBannerAnimationProps) => {
  const initializedProps: ProductAnnouncementBannerAnimationProps = {...defaultProps, ...props}
  const {sceneId} = initializedProps

  const getAnimation = useCallback((id: ProductAnnouncementBannerAnimationProps['sceneId']) => {
    if (!DOM_ANIMATION_IDS.includes(id)) return null

    if (id === 'universe25') {
      // TODO: Implement actual animation
      return <div>Animation for universe25</div>
    }
  }, [])

  if (!DOM_ANIMATION_IDS.includes(sceneId)) return null

  return <div className={Styles['ProductAnnouncementBannerAnimation']}>{getAnimation(sceneId)}</div>
}

export default ProductAnnouncementBannerAnimation
